
import GetData from "@/utils/request.js"

const {
  $get,
  $post
} = new GetData();

export const getUserSignUpList = (data) => {
  // return $get(`/h5/goods/getUserSignUpList`, data);
  return $get(`/h5/offline/getTop20UserSignUpList`, data)
}
export const getAllUserSignUpList = (data) => {
  return $get(`/h5/offline/getUserSignUpNewList`, data);
}

export const getTrainUserSign = (trainCampId) => {
  // return $get(`/h5/trainCamp/getTrainUserSign`, { trainCampId })
  return $get(`/h5/trainCamp/getTrainUserSignPhoto`, { trainCampId })
}
export const getTrainUserSignNew = (trainCampId) => {
  return $get(`/h5/trainCamp/getTrainUserSignNew`, { trainCampId })
}
// ---团购团劵领取接口---
//获取线下课分享订单详情
export const offLineOrderInfo = (data) => {
  return $get(`/h5/order/offLineOrderInfo`, data);
}
//领取线下课报名票券
export const updateSignUpBysender = (data) => {
  return $post(`/h5/order/updateSignUpBysender`, data);
}
//获取优惠券信息
export const getCouponInfo = (data) => {
  return $get(`/h5/coupon/getCouponInfo`, data);
}
//领取优惠券
export const getCoupon = (data) => {
  return $get(`/h5/coupon/getCoupon`, data);
}
// 优惠券商品
export const couponGoods = ({ id, prev }) => $get(`/h5/coupon/course/list/${id}`, { prev })

/**课程表 timetable 接口 */
export const getTrainingTimetableList = classifyId => $get('/h5/trainCamp/getTrainCampTimeList', { classifyId })

export const getTrainTimetableSchedule = resourceId => $get('/h5/trainCamp/getTrainCampByCategory', { resourceId })

export const getOfflineTimetableList = data => $get('/h5/offline/listGroup', data)

export const getCities = () => $get('/h5/offline/list/city')

export const getOneOfflineDetail = ({
  goodsId,
  courseId
}) => $get('/h5/offline/getCourseInfo', {
  goodsId,
  courseId
})

export const getOfflineClassByCategory = id => $get(`/h5/offline/getGroup/${id}`)

// 学习页相关
/**获取单个笔记 */
// id 文章id
export const getOneArticle = data => $get(`/h5/article/getItem`, data)

export const storeReadProgress = ({
  articleId, //文章id
  articleRemainId, //文章停留时长记录id
  mediaValue, //媒体进度值
  resourceId, //资源id
  textValue, //文本进度值
  type, //资源类型[0:课程,1:训练营],没有则为空
  ver, //	乐观锁版本
}) => $post('/h5/article/progress/storeReadProgress', {
  articleId,
  articleRemainId,
  mediaValue,
  resourceId,
  textValue,
  type,
  ver,
})
/**获取播放凭证 */
export const getMaterialPlayToken = articleId => $get(`/h5/av/play/token/${articleId}`)

/**商品评价 */

export const getGoodsCommentList = goodsId => $get(`/h5/goodsComment/list`, { goodsId })
export const setLikeGoodsComment = id => $post(`/h5/goodsComment/likeComment/${id}`)
export const setUnlikeGoodsComment = id => $post(`/h5/goodsComment/unLikeComment/${id}`)
/**
 * @method getGoodsCommentCount 获取商品评论统计
 * @param {Object} data 
 * @param {Number} data.goodsId 商品id
 * @param {Number} data.userId  用户id
 */
export const getGoodsCommentCount = data => $get('/h5/goodsComment/list/count', data)

export const getTrainCampLessonInfo = id => $get(`/h5/trainCamp/lessonInfo/${id}`)

export const getCourseLessonInfo = id => $get(`/h5/course/lessonInfo/${id}`)

export const getH5Cats = (goodsType) => $get(`/h5/h5Classify/list`, { goodsType })

export const getCourseList = (data) => $get(`/h5/course/list`, data)

export const getGoodsList = data => $get(`/h5/goods/list`, data)

export const getCourseCats = () => $post(`/h5/course/classify/list2`)

export const getLiveList = () => $get('/h5/liveStream/list')

export const getLiveMaterialUrl = () => $get('/h5/liveStream/latestMaterialURL')

export const getArticleComments = ({
  articleId,
  prev,
}) => {
  return $get('/h5/comments/list', {
    articleId,
    prev,
  })
}

export const delArticleComment = id => $post(`/h5/comments/delete/${id}`)

export const createArticleComments = (data) => $post('/h5/comments/create', data)

export const collectArticle = data => $post(`/h5/collect/save`, data)

export const unCollectArticle = data => $post(`/h5/collect/cancel`, data)

export const likeArticle = id => $post(`/h5/comments/like/${id}`)

export const unlikeArticle = id => $post(`/h5/comments/unLike/${id}`)


export default {
  getUserSignUpList,
  getTrainUserSign,
  getTrainUserSignNew,
  getAllUserSignUpList,
  offLineOrderInfo,
  updateSignUpBysender,
  getTrainingTimetableList,
  getTrainTimetableSchedule,
  getOfflineTimetableList,
  getCities,
  getOneOfflineDetail,
  getOfflineClassByCategory,
  getOneArticle,
  storeReadProgress,
  getMaterialPlayToken,
  getGoodsCommentList,
  setLikeGoodsComment,
  setUnlikeGoodsComment,
  getGoodsCommentCount,
  getCouponInfo,
  getCoupon,
  getTrainCampLessonInfo,
  getCourseLessonInfo,
  getH5Cats,
  getCourseList,
  getGoodsList,
  getCourseCats,
  getLiveList,
  getLiveMaterialUrl,
  couponGoods,
  getArticleComments,
  createArticleComments,
  collectArticle,
  unCollectArticle,
  likeArticle,
  unlikeArticle,
  delArticleComment,
}